'use strict';

export default typeof FormData !== 'undefined' ? FormData : null;



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/platform/browser/classes/FormData.js
// module id = 58
// module chunks = 0